import { UserPermission } from '@frontend/components/agromarket/core/access-control'
import type { Dispatch } from '@reduxjs/toolkit'
import type { History } from 'history'
import { closeModal, openModal } from '@/components/composed/Modal/actions'
import { setJwt } from '@/logic/auth/actions'
import type { IJwtPayload } from '@/logic/auth/interfaces'
import { AuthCookiesService } from '@/services'
import { ECommonRoute, EUserProfileRoute } from '@/types'
import { EInfoportalAdministrationRoute } from '@/types/Infoportal'
import { getTokenInfo } from '@/utils/helpers'
import { INN_LENGTH_OF_INDIVIDUAL_ENTREPRENEUR, INN_LENGTH_OF_LEGAL_COMPANY } from './constants'

export const hasPermission = (permissions: UserPermission[], permission: UserPermission) => permissions.includes(permission)

export const isAnyPermissionIntersected = (permissions: UserPermission[], userPermissions: UserPermission[]) =>
  userPermissions.some(permission => permissions.includes(permission))

export const getProfilePathByPermissions = (permissions: UserPermission[]) => {
  if (hasPermission(permissions, UserPermission.ADMIN)) return ECommonRoute.impersonation
  if (hasPermission(permissions, UserPermission.CONTENT_MANAGER)) return EInfoportalAdministrationRoute.MAIN
  if (hasPermission(permissions, UserPermission.RAILWAY_LOGISTIC_OPERATOR)) return EUserProfileRoute.railwayDeliveryDeals

  return EUserProfileRoute.main
}

export const getErrorMessageId = (message: string, inn: string | null | undefined) => {
  // TODO: Исправить обработку ошибок. Надо, чтобы с бэка приходило нормальное сообщение
  if (message.includes(String(inn))) return 'inn.exists'
  if (message.includes('Okved')) return 'okved.restricted'
  if (message === 'Email incorrect') return 'email.incorrect'
  if (message.includes('invalid number')) return 'wrongPhone'

  return 'default'
}

export const isInnOfIndividualEntrepreneur = (inn: string): boolean => inn.length === INN_LENGTH_OF_INDIVIDUAL_ENTREPRENEUR

export const isInnOfLegalCompany = (inn?: string): boolean => inn?.length === INN_LENGTH_OF_LEGAL_COMPANY

type HandleSuccessfullTokenSubmitOptions = {
  jwt: string
  history: History
  dispatch: Dispatch
}

export const handleSuccessfullTokenSubmit = async ({ jwt, history, dispatch }: HandleSuccessfullTokenSubmitOptions) => {
  dispatch(setJwt({ jwt }))
  AuthCookiesService.setJwt(jwt)

  const { permissions, changeOrganization } = getTokenInfo(jwt)?.payload as IJwtPayload

  if (changeOrganization) {
    dispatch(openModal({ options: { dialogId: 'ChangeActiveOrganisationModal' } }))
  } else {
    dispatch(closeModal())
  }

  if (hasPermission(permissions, UserPermission.ADMIN)) {
    history.push(ECommonRoute.impersonation)
  }

  if (hasPermission(permissions, UserPermission.CONTENT_MANAGER)) {
    history.push(EInfoportalAdministrationRoute.PUBLISHED)
  }
}
